import { Route, IndexRoute } from 'react-router';
import React from 'react';
import Layout from 'views/layout';
import App from 'views/app';
import DataUsage from 'views/dataUsage';
import TermsAndConditions from 'views/termsAndConditions';
import Contact from 'views/contact';
import Home from 'views/home';
import Signin from 'views/auth/signin';
import Logout from 'views/auth/logout';
import Register from 'views/auth/register';
import Unsubscribe from 'views/unsubscribe';
import Unsubscribed from 'views/unsubscribed';
import Subscribe from 'views/subscribe';
import Subscribed from 'views/subscribed';
import ForgotPassword from 'views/auth/forgotPassword';
import EditProfile from 'views/auth/editProfile';
import ChangeTempPassword from 'views/auth/changeTempPassword';
import Presentation from 'views/session/presentation';
import AssignContracts from 'views/staff/assignContracts';
import Programs from 'views/programs';
import Invite from 'views/invite/invite';
import { hasFeaturedPrograms } from 'services/programs'

export default store => {
  function requireAuth (nextState, transition) {
    const state = store.getState();
    if (!state.auth || !state.auth.loggedIn) {
      transition({ next: nextState.location.pathname }, '/signin');
    }
  }

  function requireStaff (nextState, transition) {
    requireAuth(nextState, transition);
    const state = store.getState();
    if (!state.profile || !state.profile.staff) {
      transition({ next: null }, '/');
    }
  }

  function requireNoAuth (nextState, transition) {
    if (nextState && nextState.location && nextState.location.query) {
      const {query} = nextState.location;
      if (query && query.fp) {
        setCookie("featuredPrograms", query.fp);
        setCookie("featuredLanguage", query.fl);
        setCookie("contractId", query.contractId);
      }
    }
    if (store.getState().auth.loggedIn) {
      if (hasFeaturedPrograms()) {
        transition({next: null}, '/programs');
      }
      else {
        transition({next: null}, '/');
      }
    }
  }

  return (
    <Route component={Layout}>
      <Route path="/" component={App}>
        <IndexRoute component={Home} />
        <Route path="signin" component={Signin} onEnter={requireNoAuth} />
        <Route path="logout" component={Logout} />
        <Route path="register" component={Register} onEnter={requireNoAuth} />
        <Route path="unsubscribe" component={Unsubscribe} />
        <Route path="unsubscribed" component={Unsubscribed} />
        <Route path="subscribe" component={Subscribe} />
        <Route path="subscribed" component={Subscribed} />
        <Route path="forgotPassword" component={ForgotPassword} />
        <Route path="profile" component={EditProfile} onEnter={requireAuth} />
        <Route
            path="changeTempPassword"
            component={ChangeTempPassword}
            onEnter={requireAuth} />
        <Route path="DataUsage" component={DataUsage} />
        <Route path="termsAndConditions" component={TermsAndConditions} />
        <Route path="contact" component={Contact} />
        <Route path="class/:id" onEnter={requireAuth}>
          <IndexRoute component={Presentation} />
          <Route path="content/:levelId" component={Presentation} />
          <Route path="content/:levelId/:slide" component={Presentation} />
        </Route>
        <Route path="staff" onEnter={requireStaff}>
          <IndexRoute component={AssignContracts} />
          <Route path="user/:userId" component={AssignContracts} />
          <Route path="session/:sessionId" component={AssignContracts} />
          <Route path="onHold" component={AssignContracts} />
        </Route>
        <Route path="/programs" component={Programs} onEnter={requireAuth} />
        <Route path="/invite" component={Invite} onEnter={requireAuth} />
      </Route>
    </Route>
  );
};




// WEBPACK FOOTER //
// ./src/router/routes.js